<template>
  <div class="jps-pp jps-static">
    <BaseContainerSpread>
      <UiPageHeader
        class="title"
        :title="{ ja: 'プライバシーポリシー', en: 'Privacy Policy'}"
        icon="koicon/koicon-30"
      />
    </BaseContainerSpread>

    <BaseContainerSpread tag="div">
      <div class="jps-static-main">
        <section class="jps-static-content">
          <h2 class="title">{{ ls(m.h1_1) }}</h2>
          <p>{{ ls(m.m1_1) }}</p>
          <p>{{ ls(m.m1_2) }}</p>
          <h2 class="title">{{ ls(m.h2_2) }}</h2>
          <p v-html="ls(m.m2_1)"></p>
          <p v-html="ls(m.m2_2)"></p>
          <h2 class="title">{{ ls(m.h3) }}</h2>
          <h3 class="">{{ ls(m.h3_1) }}</h3>

          <h4 class="">{{ ls(m.h3_1_1) }}</h4>
          <p>{{ ls(m.m3_1_2) }}</p>
          <ul class="jps-ulist">
            <li>{{ ls(m.l3_1_1) }}</li>
            <li>{{ ls(m.l3_1_2) }}</li>
            <li>{{ ls(m.l3_1_3) }}</li>
            <li>{{ ls(m.l3_1_4) }}</li>
          </ul>
          <p>{{ ls(m.m3_1_3) }}</p>

          <h4 class="">{{ ls(m.h3_2) }}</h4>
          <p v-html="ls(m.m3_2_1)"></p>
          <h4 class="">{{ ls(m.h3_3) }}</h4>
          <p v-html="ls(m.m3_3_1)"></p>
          <h4 class="">{{ ls(m.h3_4) }}</h4>
          <p v-html="ls(m.m3_4_1)"></p>
          <p v-html="ls(m.m3_4_2)"></p>
          <p>
            <strong>{{ ls(m.m3_4_3) }}</strong>
          </p>
          <p v-html="ls(m.m3_4_4)"></p>
          <p v-html="ls(m.m3_4_5)"></p>
          <p v-html="ls(m.m3_4_6)"></p>
          <p>
            <strong>{{ ls(m.m3_4_7) }}</strong>
          </p>
          <p v-html="ls(m.m3_4_8)"></p>
          <p v-html="ls(m.m3_4_9)"></p>
          <p>
            <strong>{{ ls(m.m3_4_10) }}</strong>
          </p>
          <p v-html="ls(m.m3_4_11)"></p>
          <h3 class="">{{ ls(m.h3_5) }}</h3>
          <p v-html="ls(m.m3_5_1)"></p>
          <ul class="jps-ulist">
            <li>{{ ls(m.l3_5_1) }}</li>
            <li>{{ ls(m.l3_5_2) }}</li>
            <li>{{ ls(m.l3_5_3) }}</li>
          </ul>
          <p v-html="ls(m.m3_5_2)"></p>
          <p v-html="ls(m.m3_5_3)"></p>
          <h3 class="">{{ ls(m.h3_6) }}</h3>
          <p v-html="ls(m.m3_6_1)"></p>
          <p v-html="ls(m.m3_6_2)"></p>

          <h2 class="title">{{ ls(m.h4) }}</h2>
          <p v-html="ls(m.m4_1)"></p>
          <p v-html="ls(m.m4_2)"></p>
          <h2 class="title">{{ ls(m.h5) }}</h2>
          <p v-html="ls(m.m5_1)"></p>
          <h2 class="title">{{ ls(m.h6) }}</h2>
          <p v-html="ls(m.m6_1)"></p>
          <h2 class="title">{{ ls(m.h7) }}</h2>
          <p v-html="ls(m.m7_1)"></p>
          <dl class="inquiry jps-meta">
            <dt>{{ ls(m.m7_2) }}</dt>
            <dd><a href="/contact">{{ `${config.public.serviceBaseUrl}/contact` }}</a></dd>
            <dt>{{ ls(m.l7_1) }}</dt>
            <dd>{{ ls(m.l7_2) }}</dd>
            <dt>{{ ls(m.l7_3) }}</dt>
            <dd>{{ ls(m.l7_4) }}</dd>
          </dl>
        </section>
        <div class="button-area" id="reset-cookie">
          <button class="jps-round-button" @click="showModal()">
            {{ lss('クッキーの設定をリセット', 'Reset cookie settings') }}
          </button>
        </div>
      </div>
    </BaseContainerSpread>
  </div>
</template>

<script lang="ts" setup>
definePageMeta({
  disableDefaultMargin: true,
})

const { getPageAndCache } = usePage()
const { meta } = await getPageAndCache()
useHead(meta)

const { ls, lss  } = useI18n()
const config = useRuntimeConfig()
const privacyStore = usePrivacyStore()

const showModal = () => {
  privacyStore.showPrivacyModal = true
}

let m: {
  h1_1: { ja: string; en: string };
  m1_1: { ja: string; en: string };
  m1_2: { ja: string; en: string };
  h2_2: { ja: string; en: string };
  m2_1: { ja: string; en: string };
  m2_2: { ja: string; en: string };
  h3: { ja: string; en: string };
  h3_1: { ja: string; en: string };
  h3_1_1: { ja: string; en: string };
  m3_1_2: { ja: string; en: string };
  l3_1_1: { ja: string; en: string };
  l3_1_2: { ja: string; en: string };
  l3_1_3: { ja: string; en: string };
  l3_1_4: { ja: string; en: string };
  m3_1_3: { ja: string; en: string };
  h3_2: { ja: string; en: string };
  m3_2_1: { ja: string; en: string };
  h3_3: { ja: string; en: string };
  m3_3_1: { ja: string; en: string };
  h3_4: { ja: string; en: string };
  m3_4_1: { ja: string; en: string };
  m3_4_2: { ja: string; en: string };
  m3_4_3: { ja: string; en: string };
  m3_4_4: { ja: string; en: string };
  m3_4_5: { ja: string; en: string };
  m3_4_6: { ja: string; en: string };
  m3_4_7: { ja: string; en: string };
  m3_4_8: { ja: string; en: string };
  m3_4_9: { ja: string; en: string };
  m3_4_10: { ja: string; en: string };
  m3_4_11: { ja: string; en: string };
  h3_5: { ja: string; en: string };
  m3_5_1: { ja: string; en: string };
  l3_5_1: { ja: string; en: string };
  l3_5_2: { ja: string; en: string };
  l3_5_3: { ja: string; en: string };
  m3_5_2: { ja: string; en: string };
  m3_5_3: { ja: string; en: string };
  h3_6: { ja: string; en: string };
  m3_6_1: { ja: string; en: string };
  m3_6_2: { ja: string; en: string };
  h4: { ja: string; en: string };
  m4_1: { ja: string; en: string };
  m4_2: { ja: string; en: string };
  h5: { ja: string; en: string };
  m5_1: { ja: string; en: string };
  h6: { ja: string; en: string };
  m6_1: { ja: string; en: string };
  h7: { ja: string; en: string };
  m7_1: { ja: string; en: string };
  m7_2: { ja: string; en: string };
  l7_1: { ja: string; en: string };
  l7_2: { ja: string; en: string };
  l7_3: { ja: string; en: string };
  l7_4: { ja: string; en: string }
};
m = {
  h1_1: {
    ja: `１．基本的な考え方`,
    en: `1. Basic concept`
  },
  m1_1: {
    ja: `ジャパンサーチ（${config.public.serviceBaseUrl}/で提供するウェブサイト。以下「当ウェブサイト」という。）を運用する国立国会図書館は、当ウェブサイトにおいて提供するサービスの円滑な運営に際し、利用者のプライバシー保護に配慮をしています。`,
    en: `The National Diet Library, which operates Japan Search, pays close attention to protecting the privacy of its users in smoothly operating the Japan Search website (the website provided under the following URL: ${config.public.serviceBaseUrl}/).`
  },
  m1_2: {
    ja: `また、収集した情報は利用目的の範囲内で適正に取り扱います。`,
    en: `Collected information is managed appropriately within the scope of each purpose of use.`
  },
  h2_2: {
    ja: `２．適用範囲`,
    en: `2. Scope of application`
  },
  m2_1: {
    ja: `本プライバシーポリシーは、当ウェブサイトの利用（<a href="/organization">連携機関</a>による利用を除く。）に関し、利用者の個人に関するデータ（当ウェブサイトで扱う個人に関わる情報。氏名等の個人情報だけでなく、ウェブサイトの閲覧履歴等の情報を含む。）を収集する目的とその取扱いについて説明するものです。`,
    en: `This policy describes the purpose for the NDL collecting "personal data" (any information that may identify an individual processed on the Japan Search website, including not only personal information such as names but also information such as website browsing history) and how it processes it, regarding the use of the Japan Search website except for its use by <a href="/organization">Participating Organizations</a>.`
  },
  m2_2: {
    ja: `当ウェブサイトの運用・管理は、<a href="https://www.cas.go.jp/jp/seisakukaigi/titeki2/digitalarchive_suisiniinkai/index.html">デジタルアーカイブ推進に関する検討会</a>で決定する方針の下、<a href="https://www.ndl.go.jp/">国立国会図書館</a>が行っています。本プライバシーポリシーに記載のない国立国会図書館全体の個人情報の取扱いに関しては、国立国会図書館ホームページ<a href="https://www.ndl.go.jp/jp/privacy/index.html">「国立国会図書館の個人情報の取扱いについて」</a>をご確認ください。`,
    en: `The Japan Search website is operated and managed by <a href="https://www.ndl.go.jp/en/index.html">the National Diet Library</a> under policies established by <a href="https://www.cas.go.jp/jp/seisakukaigi/titeki2/digitalarchive_suisiniinkai/index.html">the Study Group for Promoting Digital Archiving</a>. Concerning the protection of private information by the NDL as a whole, please see <a href="https://www.ndl.go.jp/en/privacy/index.html">Protection of Personal Information</a>.`,
  },
  h3: {
    ja: `３．個人に関するデータを収集する目的とその取扱いについて`,
    en: `3. Purpose of collecting and processing of personal data`
  },
  h3_1: {
    ja: `３．１　当ウェブサイトの利用における個人に関するデータの取扱い`,
    en: `3.1 Processing of personal data relating to visitors to the Japan Search website`
  },
  h3_1_1: {
    ja: `（１）収集する個人に関するデータの種類と収集目的`,
    en: `(1) Types of personal data and purpose of collection`
  },
  m3_1_2: {
    ja: `当ウェブサイトは、次の個人に関するデータを自動収集します（共有機能を利用する場合は３．２も参照）。`,
    en: `The Japan Search website automatically collects the following personal data of users (See also 3.2 for the use of sharing function).`
  },
  l3_1_1: {ja: `アクセス元のドメイン名`, en: `Internet domain names`},
  l3_1_2: {ja: `IPアドレス`, en: `IP addresses`},
  l3_1_3: {
    ja: `当ウェブサイトの閲覧履歴（アクセス日時、検索キーワード、セッション情報等）`,
    en: `Activity history on the Japan Search website (dates of access, search keyword, session information, etc.)`
  },
  l3_1_4: {ja: `端末種類情報（使用されているブラウザの種類等）`, en: `Device information (type of browser, etc.)`},
  m3_1_3: {
    ja: `収集した個人に関するデータは、当ウェブサイトの運営における業務遂行やサービス向上に資するための参考とするとともに、利用統計の作成等に使用します。`,
    en: `Personal data collected are used for reference to assist in work performance and improvement of services involved in the operation of the Japan Search website and used to produce statistics on the habits of its users.`
  },
  h3_2: {ja: `（２）個人に関するデータの取扱い`, en: `(2) Processing of personal data`},
  m3_2_1: {
    ja: `当ウェブサイトは、アクセス解析のために、当ウェブサイト独自のアクセス統計機能又はGoogle Analyticsを使用しています。当ウェブサイト独自のアクセス統計機能では、アクセスログの解析により、ページの訪問数や連携データベース等への遷移数の利用統計を作成するほか、個人を識別しない方法で当ウェブサイト利用者の利用パターンを計測します。Google Analyticsの仕組み、プライバシーポリシーについては、Google社の<a href="https://support.google.com/analytics/answer/6004245?hl=ja">「データの保護」</a>等のサイトをご確認ください。アクセス解析は統計的に実施し、個人を識別する形でデータを抽出しアクセスを分析することは行いません。利用者のカテゴライズ等に利用するこ ともありません。`,
    en: `The Japan Search website uses its own statistical function or Google Analytics for access analysis. The website's own statistical function analyzes access logs to produce usage statistics such as the number of page visits and transitions to linked databases as well as to measure the usage patterns of Japan Search website users in a manner that does not identify individual users.
Access analysis using Google Analytics extracts data in a non-personally identifiable manner and performs statistical analysis. It will not be used for categorization of users. For more information on how Google Analytics works and its privacy policy, please see Google's <a href="https://support.google.com/analytics/answer/6004245?hl=en">Data Protection</a> and other sites.`
  },
  h3_3: {ja: `（３）保存期間`, en: `(3) Retention period`},
  m3_3_1: {
    ja: `個人に関するデータを収集し取り扱う目的を達成するため、個人に関するデータの種類ごとに必要最小限の期間、個人に関するデータを保存します。不正利用の防止及びセキュリティ対策を目的とする場合、また、アクセス解析を目的とする場合は、個人に関するデータを最長で14か月間保存した後、削除します。`,
    en: `The NDL retains personal data for as long as necessary to fulfill the purposes for which it was collected and processed depending on each type of data.
For the purpose of preventing unauthorized use and security, and for the purpose of access analysis, personal data will be stored for a maximum of 14 months and then deleted.`
  },
  h3_4: {ja: `（４）クッキーの使用とその使用目的`, en: `(4) Use of cookies and purpose of their use`},
  m3_4_1: {
    ja: `当ウェブサイトは、クッキー（Cookie）を使用しています。`,
    en: `The Japan Search website uses cookies, which are small text files that are stored on users' devices (smartphones, tablets, laptops, etc.) when users visit the Japan Search website.`
  },
  m3_4_2: {
    ja: `クッキーとは、利用者がウェブサイトにアクセスしたときに、ご利用の端末（スマートフォン、タブレット、PC等）に保存される小さなテキストファイルです。`,
    en: ` `
  },
  m3_4_3: {ja: `（「必要最小限」のクッキー：常に有効）`, en: `("Strictly Necessary Cookies": Always Enabled)`},
  m3_4_4: {
    ja: `当ウェブサイトを正常に動作できるようにし、セキュリティ、ネットワーク管理、アクセシビリティなどの基本機能を正常に機能させるために必須なクッキーをあらかじめ設定しています。`,
    en: `Necessary cookies enable core functionality such as security, network management and accessibility.`
  },
  m3_4_5: {
    ja: `このクッキーは、不正なアクセスを防ぎ、潜在的なセキュリティに対する脅威を検出し軽減するためにも必要なものです。`,
    en: `These cookies are also necessary to prevent unauthorized access and to detect and mitigate potential security threats.`
  },
  m3_4_6: {
    ja: `ブラウザのクッキー設定を変更することで「必要最小限」のクッキーを無効にできますが、当ウェブサイトの機能に影響を与える場合があります。`,
    en: `Users may disable Strictly Necessary Cookies by changing their browser settings, but this may affect how the Japan Search website functions.`
  },
  m3_4_7: {
    ja: `（「全て同意」を選択した場合に設定されるクッキー：アクセス解析）`,
    en: `("Accept all Cookies": Analytics Cookies)`
  },
  m3_4_8: {
    ja: `利用者が全てのクッキーの使用に同意された場合に、国立国会図書館は、当ウェブサイトの利用状況を計測し、サービスの評価・改善に役立てるため、アクセス解析のためのクッキーを設定します。`,
    en: `If users have given their consent to accept all cookies, the NDL will set Analytics Cookies to evaluate and improve our services by measuring how users use the Japan Search website.`
  },
  m3_4_9: {
    ja: `このクッキーにより取得したデータは、当ウェブサイトの運営における業務遂行やサービス向上に資するための参考とするとともに、利用統計の作成等に使用します。アクセス解析において、個人を識別する形でデータの抽出や集計を行うことはありません。`,
    en: `Personal data collected by Analytics Cookies are used for reference to assist in work performance and improvement of services involved in the operation of the Japan Search website and used to produce statistics on the habits of its users. Access analysis extracts and collects personal data in a way that does not identify individual users.`
  },
  m3_4_10: {
    ja: `（「全て同意」を選択した場合に設定されるクッキーの解除方法）`,
    en: `(How to revoke Analytics Cookies after the user accepts all cookies)`
  },
  m3_4_11: {
    ja: `利用者はアクセス解析のためのクッキーに対する同意をいつでも取り消すことができます。取り消す場合は、本ページ下方の「クッキーの設定をリセット」ボタンを押して再度同意設定画面を表示させ、「必要最小限」を選択してください。`,
    en: `Users can revoke their consent to accept Analytics Cookies at any time. To revoke, please press the "Reset cookie settings" button at the bottom of this page to display the consent settings screen again and select "Strictly Necessary Cookies".`
  },
  h3_5: {
    ja: `３．２　当ウェブサイトの共有機能を利用する場合の個人に関するデータの取扱い`,
    en: `3.2 Processing of personal data relating to the use of sharing function`
  },
  m3_5_1: {
    ja: `利用者が当ウェブサイトの<a href="/mygallery">「マイギャラリー」</a>の共有機能を用いてデータをオンラインで共有する場合、当ウェブサイトは次の個人に関するデータを一時的に 自動保存します。`,
    en: `When users share their data by using the sharing function of <a href="/mygallery">My Gallery</a> on Japan Search, the NDL temporarily and automatically stores the following personal data:`
  },
  l3_5_1: {
    ja: `共有されるマイギャラリーのギャラリーID（自動付与）`,
    en: `The Gallery ID of the My Gallery to be shared (automatically assigned)`
  },
  l3_5_2: {ja: `当該マイギャラリー上のデータ`, en: `Data on this shared My Gallery`},
  l3_5_3: {
    ja: `当該マイギャラリーにアクセスするためのパスワード`,
    en: `The password to access this shared My Gallery`
  },
  m3_5_2: {
    ja: `国立国会図書館が、共有を可能とする以外の目的で上記のデータを利用することはありません。自動保存したこれらの個人に関するデータは、有効期限（共有開始から1日後）が過ぎたら速やかに削除します。`,
    en: `The NDL does not use this personal data except for the purpose of sharing My Gallery for users. This personal data which was automatically stored will be deleted as soon as the expiration date (one day after the start of sharing) has passed.`
  },
  m3_5_3: {
    ja: `なお、共有機能を利用しない限り、「マイギャラリー」「マイサーチ」「マイノート」等の各機能で作成したデータは、利用者の端末のブラウザ上にのみ保存され、当ウェブサイトには保存されません。`,
    en: `Unless the sharing function is used, data created by My Gallery, My Search, My Notebook, and other functions are only stored on the browser of the user's device and are not stored on the Japan Search website.`
  },
  h3_6: {
    ja: `３．３　当ウェブサイトへの問い合わせに関する個人に関するデータの取扱い`,
    en: `3.3 Processing of personal data relating to inquiries to the Japan Search website`
  },
  m3_6_1: {
    ja: `当ウェブサイトに関するお問い合わせは、<a href="/contact">「お問い合わせ」</a > から行ってください。このお問い合わせフォームで扱う氏名、電子メールアドレス、お問い合わせ内容等の個人に関するデータは、問い合わせ対応のために取り扱い、対応完了後に削除します。`,
    en: `If you have any inquiries regarding the Japan Search website, please contact us through the <a href="/contact">Contact Us</a> link. Personal data including names, email addresses and the details of your inquiries processed through this inquiry form will be used solely for the purpose of addressing inquiries and will be deleted upon completion of the response.`
  },
  m3_6_2: {
    ja: `なお、これらの個人に関するデータを連携機関又は内閣府知的財産戦略推進事務局に転送するなどの方法より、問い合わせ対応を行う場合があります。`,
    en: `In addition, the NDL may respond to inquiries by forwarding this personal data to participating organizations or the Secretariat of the Intellectual Property Strategy Headquarters of the Cabinet Office of the Government of Japan.`
  },
  h4: {ja: `４．安全管理措置`, en: `4. Measures to ensure security`},
  m4_1: {
    ja: `個人に関するデータの取扱いにおいては、漏えい、滅失又は毀損の防止その他収集した情報の安全管理のために必要かつ適切な措置を講じます。`,
    en: `The NDL takes necessary and appropriate measures in order to prevent the leakage, destruction or damage to the collected personal data, and to otherwise safely manage it.`
  },
  m4_2: {
    ja: `法令に基づく開示要請があった場合、不正アクセスや脅迫等の違法行為があった場合その他特別な理由のある場合を除き、収集した個人に関するデータを前項に掲げる目的以外の目的のために自ら利用し、又は第三者に提供しません。ただし、統計的に処理をした利用統計を公表することがあります。`,
    en: `The NDL will never use the collected personal data for any purposes other than those stated in 3 above, nor will the NDL provide it to third parties, except for particular cases where there were legal disclosure requests, illegal access, or other unlawful actions. However, the NDL may publish the statistical information mentioned in 3.1 above.`
  },
  h5: {ja: `５．個人に関するデータの設定変更`, en: `5. Changes to personal data`},
  m5_1: {
    ja: `利用者は、クッキーの使用に関する同意をいつでも取り消すことができます（３．１（４）参照）。`,
    en: `Users can revoke their consent to accept Analytics Cookies at any time (see 3.1(4)).`
  },
  h6: {ja: `６．プライバシーポリシーの改訂`, en: `6. Revision of this privacy policy`},
  m6_1: {
    ja: `本プライバシーポリシーは、改訂する場合があります。改訂する場合は、当ウェブサイトでお知らせします。改訂後の当ウェブサイトへのアクセスには、改訂されたプライバシーポリシーが適用されます。`,
    en: `This policy is subject to change. Users will be notified on this site in the event changes to the policy have been made. In this case, users' future visits to The Japan Search website will be subject to the updated policy.`
  },
  h7: {ja: `７．お問い合わせ先`, en: `7. Contact information`},
  m7_1: {
    ja: `本プライバシーポリシーに関するお問い合わせは、下記からお尋ねください。`,
    en: `If you have any questions or comments about this policy, please contact us.`
  },
  m7_2: {ja: `お問い合わせフォーム`, en: `Inquiry form`},
  l7_1: {ja: `担当部署`, en: `Department in charge`},
  l7_2: {
    ja: `国立国会図書館 電子情報部 電子情報企画課 連携協力係`, en: `Cooperation Section, Digital Information Planning Division, Digital Information Department
National Diet Library`
  },
  l7_3: {ja: `電話`, en: `Tel`},
  l7_4: {ja: `03-3581-2331（代表）`, en: `+81-3-3581-2331`},
};
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.button-area {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.jps-pp {
  .is-dark {
    .title {
      display: flex;
      flex-direction: column;
      gap: 6px;
    }
  }

  .jps-static-main {
    .jps-static-content {
      .title {
        margin-top: 2rem;
      }
    }
  }

  .inquiry {
    margin: 0 !important;
    padding: 1rem;
    background-color: $background-grey;
    border-radius: 6px;
  }
}
</style>
